
const LigneChargementCollection = function(element) {
    this.element = $(element);
    this.date    = this.element.attr('data-chargement-date');
    this.form    = this.element.closest('form');
    this.tbody   = this.element.find('table tbody');
    this.tfoot   = this.element.find('table tfoot');

    /// Bouton d'ajout de ligne
    this.element.on('form-success.modal', '[data-add-line]', (event, response) => {
        let row = this.initRow();
        this.updateRow(row, response);
    });

    /// Bouton d'ajout de commande
    this.element.on('before-load.modal', '[data-add-commande]', (event, requestData) => {
        this.setCommandeData(requestData)
    });
    this.element.on('modal-shown.modal', '[data-add-commande]', (event) => {
        const modal = event.modal;

        event.element.find('table').on('click-row.bs.table', (event, data) => {
            let row = this.initRow();

            row.find('[name$="\[commande\]"]').val(data.commande.id);

            this.updateRow(row, data);

            modal.hide();
        });
    });

    /// Edition
    this.tbody.on('before-load.modal', '[data-edit]', (event, requestData) => {
        this.setEditData($(event.currentTarget).closest('tr'), requestData)
    });
    this.tbody.on('form-success.modal', '[data-edit]', (event, response) => {
        this.updateRow($(event.currentTarget).closest('tr'), response);
    });

    /// Suppression
    this.tbody.on('click', '[data-delete]', event => {
        $(event.currentTarget).closest('tr').remove();

        this.updateTotalFooter();
    });

    this.tbody.on('keyup change', 'input', event => {
        this.updateTotalRow($(event.currentTarget).closest('tr'));
    });
};

$.extend(LigneChargementCollection.prototype, {
    setCommandeData: function(requestData) {
        let exclude = [];
        this.tbody.find('tr input[name$="\[commande\]"]').each(function() {
            let commande = $(this).val();
            if (commande) {
                exclude.push(commande);
            }
        });

        requestData.date    = this.date;
        requestData.adresse = this.form.find('input[name$="\[adresse\]"]:checked').val();
        requestData.exclude = exclude;
    },

    initRow: function() {
        let prototype = this.element.attr('data-prototype'),
            name = parseInt(this.element.attr('data-next-name'));

        prototype = prototype.replace(/__name__/g, name);

        this.element.attr('data-next-name', name + 1);

        return $(prototype).appendTo(this.tbody);
    },

    updateRow: function(row, data) {
        row.attr('data-ligne-kgs', data.isKGS ? '1' : '0');

        row.find('[name$="\[famille\]"]').val(data.famille.id);
        row.find('[data-famille]').text(data.famille.designation);

        row.find('[name$="\[origine\]"]').val(data.origine ? data.origine.id : '');
        row.find('[data-origine]').text(data.origine ? data.origine.designation : '-');

        row.find('[name$="\[calibre\]"]').val(data.calibre ? data.calibre.id : '');
        row.find('[data-calibre]').text(data.calibre ? data.calibre.designation : '-');

        row.find('[name$="\[variete\]"]').val(data.variete ? data.variete.id : '');
        row.find('[data-variete]').text(data.variete ? data.variete.designation : '-');

        row.find('[name$="\[qualite\]"]').val(data.qualite ? data.qualite.id : '');
        row.find('[data-qualite]').text(data.qualite ? data.qualite.designation : '-');

        // row.find('[name$="\[ratioQuantitePoids\]"]').val(data.ratioQuantitePoids);

        row.find('[name$="\[quantite\]"]').formatFloat(data.quantite);
        row.find('[name$="\[quantiteUnitaire\]"]').formatFloat(data.quantiteUnitaire);

        row.find('[name$="\[uniteVente\]"]').val(data.uniteVente);
        row.find('[data-unite-vente]').text(data.uniteVente);

        row.find('[name$="\[prix\]"]').formatMoney(data.prix / 100);
        row.find('[name$="\[prixUnitaire\]"]').formatMoney(data.prixUnitaire / 100);

        row.find('[name$="\[tauxTVA\]"]').val(data.tauxTVA);

        this.updateTotalRow(row);
    },

    setEditData: function(row, requestData) {
        requestData.famille = row.find('[name$="\[famille\]"]').val();
        requestData.origine = row.find('[name$="\[origine\]"]').val();
        requestData.calibre = row.find('[name$="\[calibre\]"]').val();
        requestData.variete = row.find('[name$="\[variete\]"]').val();
        requestData.qualite = row.find('[name$="\[qualite\]"]').val();
        requestData.quantiteUnitaire = row.find('[name$="\[quantiteUnitaire\]"]').val();
        requestData.prixUnitaire = row.find('[name$="\[prixUnitaire\]"]').parseMoney() * 100;
    },

    updateTotalRow: function(row) {
        let quantiteUnitaire = row.find('[name$="\[quantiteUnitaire\]"]').parseFloat(),
            prixUnitaire = row.find('[name$="\[prixUnitaire\]"]').parseMoney(),
            totalHT = prixUnitaire * quantiteUnitaire;

        row.find('[name$="\[totalHT\]"]').formatMoney(totalHT);

        // Refresh champs KGS
        let quantite = row.find('[name$="\[quantite\]"]').parseFloat(),
            prix = Math.ceil(totalHT * 100. / quantite) / 100.;

        row.find('[name$="\[prix\]"]').formatMoney(prix);

        // Refresh quantite KGS if line is KGS
        if (row.attr('data-ligne-kgs') === '1') {
            row.find('[name$="\[quantite\]"]').formatFloat(quantiteUnitaire);
            row.find('[name$="\[prix\]"]').val(prixUnitaire);
        }

        this.updateTotalFooter();
    },

    updateTotalFooter: function() {
        let totalHT = 0;

        this.tbody.find('[name$="\[totalHT\]"]').each(function() {
            totalHT += $(this).parseMoney();
        });

        this.tfoot.find('input[name=totalHT]').formatMoney(totalHT);
    }
});

const ligneChargementCollection = () => {
    const selector = 'div[data-ligne-chargement-collection]';

    $(document).arrive(selector, {
        existing: true
    }, function() {
        new LigneChargementCollection(this);
    });
};

export { ligneChargementCollection }


// WEBPACK FOOTER //
// ./js/form/ligneChargementCollection.js